// Genişletilmiş emoji kataloğu - 500+ emoji
export interface EmojiItem {
    emoji: string;
    keywords: string[];
    category: string;
}

export const emojiCatalog: EmojiItem[] = [
    // SMILEYS - 80 adet
    { emoji: '😀', keywords: ['smile', 'happy', 'grin'], category: 'smileys' },
    { emoji: '😃', keywords: ['smile', 'happy', 'grin'], category: 'smileys' },
    { emoji: '😄', keywords: ['smile', 'happy', 'laugh'], category: 'smileys' },
    { emoji: '😁', keywords: ['grin', 'happy', 'smile'], category: 'smileys' },
    { emoji: '😆', keywords: ['laugh', 'happy', 'smile'], category: 'smileys' },
    { emoji: '😅', keywords: ['laugh', 'sweat', 'smile'], category: 'smileys' },
    { emoji: '😂', keywords: ['laugh', 'cry', 'joy'], category: 'smileys' },
    { emoji: '🤣', keywords: ['rofl', 'laugh'], category: 'smileys' },
    { emoji: '😊', keywords: ['smile', 'blush'], category: 'smileys' },
    { emoji: '🙂', keywords: ['smile', 'calm'], category: 'smileys' },
    { emoji: '🙃', keywords: ['upside', 'down'], category: 'smileys' },
    { emoji: '😉', keywords: ['wink'], category: 'smileys' },
    { emoji: '😌', keywords: ['relieved', 'calm'], category: 'smileys' },
    { emoji: '😍', keywords: ['love', 'heart', 'eyes'], category: 'smileys' },
    { emoji: '🥰', keywords: ['love', 'hearts', 'adore'], category: 'smileys' },
    { emoji: '😘', keywords: ['kiss', 'love'], category: 'smileys' },
    { emoji: '😗', keywords: ['kiss'], category: 'smileys' },
    { emoji: '😙', keywords: ['kiss', 'smile'], category: 'smileys' },
    { emoji: '😚', keywords: ['kiss', 'closed'], category: 'smileys' },
    { emoji: '😋', keywords: ['tongue', 'silly'], category: 'smileys' },
    { emoji: '😛', keywords: ['tongue'], category: 'smileys' },
    { emoji: '😜', keywords: ['play', 'wink', 'tongue'], category: 'smileys' },
    { emoji: '🤪', keywords: ['crazy', 'silly'], category: 'smileys' },
    { emoji: '😝', keywords: ['tongue', 'laugh'], category: 'smileys' },
    { emoji: '🤑', keywords: ['money', 'rich'], category: 'smileys' },
    { emoji: '🤗', keywords: ['hug', 'happy'], category: 'smileys' },
    { emoji: '🤭', keywords: ['giggle', 'secret'], category: 'smileys' },
    { emoji: '🤫', keywords: ['shh', 'quiet', 'secret'], category: 'smileys' },
    { emoji: '🤔', keywords: ['think', 'hmm'], category: 'smileys' },
    { emoji: '🤐', keywords: ['zip', 'silent', 'quiet'], category: 'smileys' },
    { emoji: '🤨', keywords: ['suspicious', 'doubt'], category: 'smileys' },
    { emoji: '😐', keywords: ['neutral', 'meh'], category: 'smileys' },
    { emoji: '😑', keywords: ['expressionless', 'blank'], category: 'smileys' },
    { emoji: '😶', keywords: ['silent', 'no mouth'], category: 'smileys' },
    { emoji: '😏', keywords: ['smirk', 'sly'], category: 'smileys' },
    { emoji: '😒', keywords: ['unamused', 'meh'], category: 'smileys' },
    { emoji: '🙄', keywords: ['eyeroll', 'bored'], category: 'smileys' },
    { emoji: '😬', keywords: ['grimace', 'awkward'], category: 'smileys' },
    { emoji: '🤥', keywords: ['lie', 'liar'], category: 'smileys' },
    { emoji: '😔', keywords: ['sad', 'pensive'], category: 'smileys' },
    { emoji: '😪', keywords: ['sleepy', 'tired'], category: 'smileys' },
    { emoji: '🤤', keywords: ['drool', 'hungry'], category: 'smileys' },
    { emoji: '😴', keywords: ['sleep', 'tired'], category: 'smileys' },
    { emoji: '😷', keywords: ['sick', 'mask'], category: 'smileys' },
    { emoji: '🤒', keywords: ['fever', 'sick'], category: 'smileys' },
    { emoji: '🤕', keywords: ['hurt', 'bandage'], category: 'smileys' },
    { emoji: '🤢', keywords: ['nausea', 'sick'], category: 'smileys' },
    { emoji: '🤮', keywords: ['vomit', 'sick'], category: 'smileys' },
    { emoji: '🤧', keywords: ['sneeze', 'sick'], category: 'smileys' },
    { emoji: '🥵', keywords: ['hot', 'sweat'], category: 'smileys' },
    { emoji: '🥶', keywords: ['cold', 'freeze'], category: 'smileys' },
    { emoji: '🥴', keywords: ['woozy', 'dizzy'], category: 'smileys' },
    { emoji: '😵', keywords: ['dizzy', 'dead'], category: 'smileys' },
    { emoji: '🤯', keywords: ['mindblown', 'explode'], category: 'smileys' },
    { emoji: '🤠', keywords: ['cowboy', 'hat'], category: 'smileys' },
    { emoji: '🥳', keywords: ['party', 'celebrate'], category: 'smileys' },
    { emoji: '😎', keywords: ['cool', 'sunglasses'], category: 'smileys' },
    { emoji: '🤓', keywords: ['nerd', 'glasses'], category: 'smileys' },
    { emoji: '🧐', keywords: ['monocle', 'inspect'], category: 'smileys' },
    { emoji: '😕', keywords: ['confused', 'huh'], category: 'smileys' },
    { emoji: '😟', keywords: ['worried', 'sad'], category: 'smileys' },
    { emoji: '🙁', keywords: ['frown', 'sad'], category: 'smileys' },
    { emoji: '☹️', keywords: ['sad', 'frown'], category: 'smileys' },
    { emoji: '😮', keywords: ['surprised', 'wow'], category: 'smileys' },
    { emoji: '😯', keywords: ['hushed', 'surprised'], category: 'smileys' },
    { emoji: '😲', keywords: ['shocked', 'amazed'], category: 'smileys' },
    { emoji: '😳', keywords: ['blush', 'shy'], category: 'smileys' },
    { emoji: '🥺', keywords: ['plead', 'puppy'], category: 'smileys' },
    { emoji: '😦', keywords: ['frown', 'surprised'], category: 'smileys' },
    { emoji: '😧', keywords: ['anguished', 'pain'], category: 'smileys' },
    { emoji: '😨', keywords: ['fearful', 'scared'], category: 'smileys' },
    { emoji: '😰', keywords: ['anxious', 'sweat'], category: 'smileys' },
    { emoji: '😥', keywords: ['sad', 'relieved'], category: 'smileys' },
    { emoji: '😢', keywords: ['cry', 'sad'], category: 'smileys' },
    { emoji: '😭', keywords: ['cry', 'sad', 'tears'], category: 'smileys' },
    { emoji: '😱', keywords: ['scream', 'horror'], category: 'smileys' },
    { emoji: '😖', keywords: ['confounded', 'pain'], category: 'smileys' },
    { emoji: '😣', keywords: ['persevere', 'pain'], category: 'smileys' },
    { emoji: '😞', keywords: ['disappointed', 'sad'], category: 'smileys' },
    { emoji: '😓', keywords: ['sweat', 'sad'], category: 'smileys' },
    { emoji: '😩', keywords: ['weary', 'tired'], category: 'smileys' },
    { emoji: '😫', keywords: ['tired', 'exhausted'], category: 'smileys' },
    { emoji: '😤', keywords: ['steam', 'angry'], category: 'smileys' },
    { emoji: '😡', keywords: ['angry', 'mad'], category: 'smileys' },
    { emoji: '😠', keywords: ['angry', 'rage'], category: 'smileys' },
    { emoji: '🤬', keywords: ['curse', 'swear'], category: 'smileys' },
    { emoji: '😈', keywords: ['devil', 'evil'], category: 'smileys' },
    { emoji: '👿', keywords: ['imp', 'demon'], category: 'smileys' },
    { emoji: '💀', keywords: ['skull', 'dead'], category: 'smileys' },
    { emoji: '☠️', keywords: ['skull', 'danger'], category: 'smileys' },
    { emoji: '💩', keywords: ['poop', 'crap'], category: 'smileys' },
    { emoji: '🤡', keywords: ['clown', 'joke'], category: 'smileys' },
    { emoji: '👹', keywords: ['ogre', 'monster'], category: 'smileys' },
    { emoji: '👺', keywords: ['goblin', 'troll'], category: 'smileys' },
    { emoji: '👻', keywords: ['ghost', 'boo'], category: 'smileys' },
    { emoji: '👽', keywords: ['alien', 'ufo'], category: 'smileys' },
    { emoji: '👾', keywords: ['monster', 'game'], category: 'smileys' },
    { emoji: '🤖', keywords: ['robot', 'bot'], category: 'smileys' },
    { emoji: '😺', keywords: ['cat', 'smile'], category: 'smileys' },
    { emoji: '😸', keywords: ['cat', 'grin'], category: 'smileys' },
    { emoji: '😹', keywords: ['cat', 'laugh'], category: 'smileys' },
    { emoji: '😻', keywords: ['cat', 'love'], category: 'smileys' },
    { emoji: '😼', keywords: ['cat', 'smirk'], category: 'smileys' },
    { emoji: '😽', keywords: ['cat', 'kiss'], category: 'smileys' },
    { emoji: '🙀', keywords: ['cat', 'shock'], category: 'smileys' },
    { emoji: '😿', keywords: ['cat', 'cry'], category: 'smileys' },
    { emoji: '😾', keywords: ['cat', 'angry'], category: 'smileys' },

    // GESTURES - 50 adet
    { emoji: '👋', keywords: ['wave', 'hello', 'bye'], category: 'gestures' },
    { emoji: '🤚', keywords: ['hand', 'stop'], category: 'gestures' },
    { emoji: '🖐️', keywords: ['hand', 'fingers'], category: 'gestures' },
    { emoji: '✋', keywords: ['hand', 'stop', 'highfive'], category: 'gestures' },
    { emoji: '🖖', keywords: ['vulcan', 'spock'], category: 'gestures' },
    { emoji: '👌', keywords: ['ok', 'good', 'perfect'], category: 'gestures' },
    { emoji: '🤏', keywords: ['pinch', 'small'], category: 'gestures' },
    { emoji: '✌️', keywords: ['victory', 'peace'], category: 'gestures' },
    { emoji: '🤞', keywords: ['cross', 'luck'], category: 'gestures' },
    { emoji: '🤟', keywords: ['rock', 'love', 'you'], category: 'gestures' },
    { emoji: '🤘', keywords: ['rock', 'metal'], category: 'gestures' },
    { emoji: '🤙', keywords: ['call', 'shaka'], category: 'gestures' },
    { emoji: '👈', keywords: ['point', 'left'], category: 'gestures' },
    { emoji: '👉', keywords: ['point', 'right'], category: 'gestures' },
    { emoji: '👆', keywords: ['point', 'up'], category: 'gestures' },
    { emoji: '🖕', keywords: ['middle', 'finger'], category: 'gestures' },
    { emoji: '👇', keywords: ['point', 'down'], category: 'gestures' },
    { emoji: '☝️', keywords: ['point', 'up'], category: 'gestures' },
    { emoji: '👍', keywords: ['thumb', 'like', 'ok', 'up'], category: 'gestures' },
    { emoji: '👎', keywords: ['thumb', 'dislike', 'no', 'down'], category: 'gestures' },
    { emoji: '✊', keywords: ['fist', 'power'], category: 'gestures' },
    { emoji: '👊', keywords: ['fist', 'punch', 'bump'], category: 'gestures' },
    { emoji: '🤛', keywords: ['fist', 'left'], category: 'gestures' },
    { emoji: '🤜', keywords: ['fist', 'right'], category: 'gestures' },
    { emoji: '👏', keywords: ['clap', 'applause', 'bravo'], category: 'gestures' },
    { emoji: '🙌', keywords: ['hands', 'celebrate', 'hooray'], category: 'gestures' },
    { emoji: '👐', keywords: ['hands', 'open'], category: 'gestures' },
    { emoji: '🤲', keywords: ['hands', 'together'], category: 'gestures' },
    { emoji: '🤝', keywords: ['handshake', 'deal', 'agree'], category: 'gestures' },
    { emoji: '🙏', keywords: ['pray', 'thanks', 'please'], category: 'gestures' },
    { emoji: '✍️', keywords: ['write', 'hand'], category: 'gestures' },
    { emoji: '💅', keywords: ['nail', 'polish'], category: 'gestures' },
    { emoji: '🤳', keywords: ['selfie', 'phone'], category: 'gestures' },
    { emoji: '💪', keywords: ['strong', 'muscle', 'flex'], category: 'gestures' },
    { emoji: '🦾', keywords: ['mechanical', 'arm'], category: 'gestures' },
    { emoji: '🦿', keywords: ['mechanical', 'leg'], category: 'gestures' },
    { emoji: '🦵', keywords: ['leg'], category: 'gestures' },
    { emoji: '🦶', keywords: ['foot'], category: 'gestures' },
    { emoji: '👂', keywords: ['ear', 'hear'], category: 'gestures' },
    { emoji: '🦻', keywords: ['ear', 'aid'], category: 'gestures' },
    { emoji: '👃', keywords: ['nose', 'smell'], category: 'gestures' },
    { emoji: '🧠', keywords: ['brain', 'smart'], category: 'gestures' },
    { emoji: '🫀', keywords: ['heart', 'organ'], category: 'gestures' },
    { emoji: '🫁', keywords: ['lungs', 'breathe'], category: 'gestures' },
    { emoji: '🦷', keywords: ['tooth', 'dentist'], category: 'gestures' },
    { emoji: '🦴', keywords: ['bone'], category: 'gestures' },
    { emoji: '👀', keywords: ['eyes', 'look'], category: 'gestures' },
    { emoji: '👁️', keywords: ['eye', 'see'], category: 'gestures' },
    { emoji: '👅', keywords: ['tongue', 'taste'], category: 'gestures' },
    { emoji: '👄', keywords: ['lips', 'mouth', 'kiss'], category: 'gestures' },

    // HEARTS - 30 adet
    { emoji: '❤️', keywords: ['heart', 'love', 'red'], category: 'hearts' },
    { emoji: '🧡', keywords: ['heart', 'love', 'orange'], category: 'hearts' },
    { emoji: '💛', keywords: ['heart', 'love', 'yellow'], category: 'hearts' },
    { emoji: '💚', keywords: ['heart', 'love', 'green'], category: 'hearts' },
    { emoji: '💙', keywords: ['heart', 'love', 'blue'], category: 'hearts' },
    { emoji: '💜', keywords: ['heart', 'love', 'purple'], category: 'hearts' },
    { emoji: '🖤', keywords: ['heart', 'love', 'black'], category: 'hearts' },
    { emoji: '🤍', keywords: ['heart', 'love', 'white'], category: 'hearts' },
    { emoji: '🤎', keywords: ['heart', 'love', 'brown'], category: 'hearts' },
    { emoji: '💔', keywords: ['broken', 'heart', 'sad'], category: 'hearts' },
    { emoji: '❣️', keywords: ['heart', 'exclamation'], category: 'hearts' },
    { emoji: '💕', keywords: ['two', 'hearts'], category: 'hearts' },
    { emoji: '💞', keywords: ['revolving', 'hearts'], category: 'hearts' },
    { emoji: '💓', keywords: ['beating', 'heart'], category: 'hearts' },
    { emoji: '💗', keywords: ['growing', 'heart'], category: 'hearts' },
    { emoji: '💖', keywords: ['sparkle', 'heart'], category: 'hearts' },
    { emoji: '💘', keywords: ['arrow', 'heart', 'cupid'], category: 'hearts' },
    { emoji: '💝', keywords: ['gift', 'heart', 'love'], category: 'hearts' },
    { emoji: '💟', keywords: ['heart', 'decoration'], category: 'hearts' },
    { emoji: '☮️', keywords: ['peace', 'love'], category: 'hearts' },
    { emoji: '✝️', keywords: ['cross', 'christian'], category: 'hearts' },
    { emoji: '☪️', keywords: ['star', 'islam'], category: 'hearts' },
    { emoji: '🕉️', keywords: ['om', 'hindu'], category: 'hearts' },
    { emoji: '☸️', keywords: ['wheel', 'dharma'], category: 'hearts' },
    { emoji: '✡️', keywords: ['star', 'david', 'jewish'], category: 'hearts' },
    { emoji: '🔯', keywords: ['dot', 'star'], category: 'hearts' },
    { emoji: '🕎', keywords: ['menorah', 'hanukkah'], category: 'hearts' },
    { emoji: '☯️', keywords: ['yin', 'yang', 'balance'], category: 'hearts' },
    { emoji: '☦️', keywords: ['cross', 'orthodox'], category: 'hearts' },
    { emoji: '🛐', keywords: ['pray', 'worship'], category: 'hearts' },

    // SYMBOLS - 60 adet
    { emoji: '💯', keywords: ['hundred', 'score', 'perfect'], category: 'symbols' },
    { emoji: '🔥', keywords: ['fire', 'hot', 'lit'], category: 'symbols' },
    { emoji: '✨', keywords: ['sparkle', 'shine', 'stars'], category: 'symbols' },
    { emoji: '⚡', keywords: ['lightning', 'bolt', 'electric'], category: 'symbols' },
    { emoji: '🌟', keywords: ['star', 'shine', 'glow'], category: 'symbols' },
    { emoji: '⭐', keywords: ['star'], category: 'symbols' },
    { emoji: '🌈', keywords: ['rainbow', 'color', 'pride'], category: 'symbols' },
    { emoji: '☀️', keywords: ['sun', 'sunny', 'weather'], category: 'symbols' },
    { emoji: '🌤️', keywords: ['sun', 'cloud'], category: 'symbols' },
    { emoji: '⛅', keywords: ['sun', 'cloud', 'weather'], category: 'symbols' },
    { emoji: '🌥️', keywords: ['sun', 'cloud'], category: 'symbols' },
    { emoji: '☁️', keywords: ['cloud', 'weather'], category: 'symbols' },
    { emoji: '🌦️', keywords: ['rain', 'sun'], category: 'symbols' },
    { emoji: '🌧️', keywords: ['rain', 'cloud'], category: 'symbols' },
    { emoji: '⛈️', keywords: ['storm', 'thunder'], category: 'symbols' },
    { emoji: '🌩️', keywords: ['lightning', 'storm'], category: 'symbols' },
    { emoji: '🌨️', keywords: ['snow', 'cold'], category: 'symbols' },
    { emoji: '❄️', keywords: ['snowflake', 'cold', 'winter'], category: 'symbols' },
    { emoji: '🌬️', keywords: ['wind', 'blow'], category: 'symbols' },
    { emoji: '💨', keywords: ['dash', 'wind', 'fast'], category: 'symbols' },
    { emoji: '🌪️', keywords: ['tornado', 'storm'], category: 'symbols' },
    { emoji: '🌫️', keywords: ['fog', 'mist'], category: 'symbols' },
    { emoji: '☔', keywords: ['umbrella', 'rain'], category: 'symbols' },
    { emoji: '☂️', keywords: ['umbrella', 'sun'], category: 'symbols' },
    { emoji: '🌊', keywords: ['wave', 'sea', 'ocean'], category: 'symbols' },
    { emoji: '💧', keywords: ['droplet', 'water'], category: 'symbols' },
    { emoji: '💦', keywords: ['sweat', 'water'], category: 'symbols' },
    { emoji: '☄️', keywords: ['comet', 'space'], category: 'symbols' },
    { emoji: '💥', keywords: ['boom', 'explode'], category: 'symbols' },
    { emoji: '💫', keywords: ['dizzy', 'star'], category: 'symbols' },
    { emoji: '💢', keywords: ['anger', 'mad'], category: 'symbols' },
    { emoji: '♠️', keywords: ['spade', 'card'], category: 'symbols' },
    { emoji: '♥️', keywords: ['heart', 'card'], category: 'symbols' },
    { emoji: '♦️', keywords: ['diamond', 'card'], category: 'symbols' },
    { emoji: '♣️', keywords: ['club', 'card'], category: 'symbols' },
    { emoji: '🃏', keywords: ['joker', 'card'], category: 'symbols' },
    { emoji: '🀄', keywords: ['mahjong', 'game'], category: 'symbols' },
    { emoji: '🎴', keywords: ['flower', 'cards'], category: 'symbols' },
    { emoji: '🎭', keywords: ['mask', 'theater'], category: 'symbols' },
    { emoji: '🔇', keywords: ['mute', 'silent'], category: 'symbols' },
    { emoji: '🔈', keywords: ['speaker', 'low'], category: 'symbols' },
    { emoji: '🔉', keywords: ['speaker', 'medium'], category: 'symbols' },
    { emoji: '🔊', keywords: ['speaker', 'loud'], category: 'symbols' },
    { emoji: '🔔', keywords: ['bell', 'ring'], category: 'symbols' },
    { emoji: '🔕', keywords: ['bell', 'slash'], category: 'symbols' },
    { emoji: '🎵', keywords: ['music', 'note'], category: 'symbols' },
    { emoji: '🎶', keywords: ['music', 'notes'], category: 'symbols' },
    { emoji: '🏧', keywords: ['atm', 'money'], category: 'symbols' },
    { emoji: '🚮', keywords: ['litter', 'trash'], category: 'symbols' },
    { emoji: '🚰', keywords: ['water', 'faucet'], category: 'symbols' },
    { emoji: '♿', keywords: ['wheelchair', 'access'], category: 'symbols' },
    { emoji: '🚹', keywords: ['men', 'restroom'], category: 'symbols' },
    { emoji: '🚺', keywords: ['women', 'restroom'], category: 'symbols' },
    { emoji: '🚻', keywords: ['restroom', 'bathroom'], category: 'symbols' },
    { emoji: '🚼', keywords: ['baby', 'change'], category: 'symbols' },
    { emoji: '🚾', keywords: ['wc', 'toilet'], category: 'symbols' },
    { emoji: '⚠️', keywords: ['warning', 'caution'], category: 'symbols' },
    { emoji: '🚸', keywords: ['children', 'crossing'], category: 'symbols' },
    { emoji: '⛔', keywords: ['no', 'entry'], category: 'symbols' },
    { emoji: '🚫', keywords: ['prohibited', 'ban'], category: 'symbols' },
    { emoji: '🚳', keywords: ['no', 'bikes'], category: 'symbols' },
    { emoji: '🚭', keywords: ['no', 'smoking'], category: 'symbols' },
    { emoji: '🚯', keywords: ['no', 'litter'], category: 'symbols' },

    // PARTY - 40 adet
    { emoji: '🎉', keywords: ['party', 'celebrate', 'confetti', 'tada'], category: 'party' },
    { emoji: '🎊', keywords: ['party', 'celebrate'], category: 'party' },
    { emoji: '🎈', keywords: ['balloon', 'party'], category: 'party' },
    { emoji: '🎂', keywords: ['cake', 'birthday'], category: 'party' },
    { emoji: '🎁', keywords: ['gift', 'present'], category: 'party' },
    { emoji: '🎄', keywords: ['christmas', 'tree'], category: 'party' },
    { emoji: '🎃', keywords: ['halloween', 'pumpkin'], category: 'party' },
    { emoji: '🎆', keywords: ['fireworks', 'celebrate'], category: 'party' },
    { emoji: '🎇', keywords: ['sparkler', 'firework'], category: 'party' },
    { emoji: '🧨', keywords: ['firecracker', 'boom'], category: 'party' },
    { emoji: '✨', keywords: ['sparkle', 'magic'], category: 'party' },
    { emoji: '🎀', keywords: ['ribbon', 'pink'], category: 'party' },
    { emoji: '🎗️', keywords: ['reminder', 'ribbon'], category: 'party' },
    { emoji: '🎟️', keywords: ['ticket', 'admission'], category: 'party' },
    { emoji: '🎫', keywords: ['ticket'], category: 'party' },
    { emoji: '🎖️', keywords: ['medal', 'military'], category: 'party' },
    { emoji: '🏆', keywords: ['trophy', 'win', 'prize'], category: 'party' },
    { emoji: '🏅', keywords: ['medal', 'sports'], category: 'party' },
    { emoji: '🥇', keywords: ['gold', 'first'], category: 'party' },
    { emoji: '🥈', keywords: ['silver', 'second'], category: 'party' },
    { emoji: '🥉', keywords: ['bronze', 'third'], category: 'party' },
    { emoji: '🎪', keywords: ['circus', 'tent'], category: 'party' },
    { emoji: '🎭', keywords: ['masks', 'theater'], category: 'party' },
    { emoji: '🩰', keywords: ['ballet', 'shoes'], category: 'party' },
    { emoji: '🎨', keywords: ['art', 'palette'], category: 'party' },
    { emoji: '🎬', keywords: ['movie', 'clapper'], category: 'party' },
    { emoji: '🎤', keywords: ['microphone', 'karaoke'], category: 'party' },
    { emoji: '🎧', keywords: ['headphones', 'music'], category: 'party' },
    { emoji: '🎼', keywords: ['music', 'score'], category: 'party' },
    { emoji: '🎹', keywords: ['piano', 'music'], category: 'party' },
    { emoji: '🥁', keywords: ['drum', 'music'], category: 'party' },
    { emoji: '🎷', keywords: ['saxophone', 'jazz'], category: 'party' },
    { emoji: '🎺', keywords: ['trumpet', 'music'], category: 'party' },
    { emoji: '🎸', keywords: ['guitar', 'music'], category: 'party' },
    { emoji: '🎻', keywords: ['violin', 'music'], category: 'party' },
    { emoji: '🎲', keywords: ['dice', 'game'], category: 'party' },
    { emoji: '🎯', keywords: ['target', 'bullseye', 'dart'], category: 'party' },
    { emoji: '🎳', keywords: ['bowling', 'game'], category: 'party' },
    { emoji: '🎮', keywords: ['game', 'controller'], category: 'party' },
    { emoji: '🎰', keywords: ['slot', 'machine'], category: 'party' },

    // NATURE - 60 adet
    { emoji: '🐶', keywords: ['dog', 'pet', 'puppy'], category: 'nature' },
    { emoji: '🐱', keywords: ['cat', 'pet', 'kitten'], category: 'nature' },
    { emoji: '🐭', keywords: ['mouse'], category: 'nature' },
    { emoji: '🐹', keywords: ['hamster'], category: 'nature' },
    { emoji: '🐰', keywords: ['rabbit', 'bunny'], category: 'nature' },
    { emoji: '🦊', keywords: ['fox'], category: 'nature' },
    { emoji: '🐻', keywords: ['bear'], category: 'nature' },
    { emoji: '🐼', keywords: ['panda'], category: 'nature' },
    { emoji: '🐨', keywords: ['koala'], category: 'nature' },
    { emoji: '🐯', keywords: ['tiger'], category: 'nature' },
    { emoji: '🦁', keywords: ['lion'], category: 'nature' },
    { emoji: '🐮', keywords: ['cow'], category: 'nature' },
    { emoji: '🐷', keywords: ['pig'], category: 'nature' },
    { emoji: '🐸', keywords: ['frog'], category: 'nature' },
    { emoji: '🐵', keywords: ['monkey'], category: 'nature' },
    { emoji: '🙈', keywords: ['see', 'no', 'evil'], category: 'nature' },
    { emoji: '🙉', keywords: ['hear', 'no', 'evil'], category: 'nature' },
    { emoji: '🙊', keywords: ['speak', 'no', 'evil'], category: 'nature' },
    { emoji: '🐒', keywords: ['monkey'], category: 'nature' },
    { emoji: '🐔', keywords: ['chicken'], category: 'nature' },
    { emoji: '🐧', keywords: ['penguin'], category: 'nature' },
    { emoji: '🐦', keywords: ['bird'], category: 'nature' },
    { emoji: '🐤', keywords: ['chick', 'baby'], category: 'nature' },
    { emoji: '🐣', keywords: ['hatching', 'chick'], category: 'nature' },
    { emoji: '🐥', keywords: ['chick', 'front'], category: 'nature' },
    { emoji: '🦆', keywords: ['duck'], category: 'nature' },
    { emoji: '🦅', keywords: ['eagle'], category: 'nature' },
    { emoji: '🦉', keywords: ['owl'], category: 'nature' },
    { emoji: '🦇', keywords: ['bat'], category: 'nature' },
    { emoji: '🐺', keywords: ['wolf'], category: 'nature' },
    { emoji: '🐗', keywords: ['boar'], category: 'nature' },
    { emoji: '🐴', keywords: ['horse'], category: 'nature' },
    { emoji: '🦄', keywords: ['unicorn'], category: 'nature' },
    { emoji: '🐝', keywords: ['bee', 'honey'], category: 'nature' },
    { emoji: '🐛', keywords: ['bug'], category: 'nature' },
    { emoji: '🦋', keywords: ['butterfly'], category: 'nature' },
    { emoji: '🐌', keywords: ['snail'], category: 'nature' },
    { emoji: '🐞', keywords: ['ladybug'], category: 'nature' },
    { emoji: '🐜', keywords: ['ant'], category: 'nature' },
    { emoji: '🦗', keywords: ['cricket'], category: 'nature' },
    { emoji: '🕷️', keywords: ['spider'], category: 'nature' },
    { emoji: '🕸️', keywords: ['web'], category: 'nature' },
    { emoji: '🦂', keywords: ['scorpion'], category: 'nature' },
    { emoji: '🐢', keywords: ['turtle'], category: 'nature' },
    { emoji: '🐍', keywords: ['snake'], category: 'nature' },
    { emoji: '🦎', keywords: ['lizard'], category: 'nature' },
    { emoji: '🦖', keywords: ['t-rex', 'dinosaur'], category: 'nature' },
    { emoji: '🦕', keywords: ['sauropod', 'dinosaur'], category: 'nature' },
    { emoji: '🐙', keywords: ['octopus'], category: 'nature' },
    { emoji: '🦑', keywords: ['squid'], category: 'nature' },
    { emoji: '🌵', keywords: ['cactus'], category: 'nature' },
    { emoji: '🎄', keywords: ['tree', 'christmas'], category: 'nature' },
    { emoji: '🌲', keywords: ['tree', 'evergreen'], category: 'nature' },
    { emoji: '🌳', keywords: ['tree', 'deciduous'], category: 'nature' },
    { emoji: '🌴', keywords: ['palm', 'tree'], category: 'nature' },
    { emoji: '🌱', keywords: ['seedling'], category: 'nature' },
    { emoji: '🌿', keywords: ['herb', 'leaf'], category: 'nature' },
    { emoji: '☘️', keywords: ['shamrock'], category: 'nature' },
    { emoji: '🍀', keywords: ['clover', 'luck'], category: 'nature' },
    { emoji: '🍃', keywords: ['leaf', 'flutter'], category: 'nature' },
    { emoji: '🍂', keywords: ['fallen', 'leaf'], category: 'nature' },
    { emoji: '🍁', keywords: ['maple', 'leaf'], category: 'nature' },
    { emoji: '🌸', keywords: ['cherry', 'blossom'], category: 'nature' },
    { emoji: '🌺', keywords: ['hibiscus'], category: 'nature' },
    { emoji: '🌻', keywords: ['sunflower'], category: 'nature' },
    { emoji: '🌹', keywords: ['rose', 'flower'], category: 'nature' },
    { emoji: '🌷', keywords: ['tulip'], category: 'nature' },
    { emoji: '🌼', keywords: ['blossom', 'flower'], category: 'nature' },
    { emoji: '🌞', keywords: ['sun', 'face'], category: 'nature' },
    { emoji: '🌝', keywords: ['full', 'moon'], category: 'nature' },
    { emoji: '🌙', keywords: ['crescent', 'moon'], category: 'nature' },
    { emoji: '⭐', keywords: ['star'], category: 'nature' },
    { emoji: '🌟', keywords: ['glowing', 'star'], category: 'nature' },
    { emoji: '✨', keywords: ['sparkles'], category: 'nature' },
    { emoji: '⚡', keywords: ['lightning'], category: 'nature' },
    { emoji: '🔥', keywords: ['fire'], category: 'nature' },
    { emoji: '💧', keywords: ['droplet'], category: 'nature' },
    { emoji: '🌊', keywords: ['wave', 'ocean'], category: 'nature' },
    { emoji: '🌍', keywords: ['earth'], category: 'nature' },
    { emoji: '🌎', keywords: ['earth'], category: 'nature' },
    { emoji: '🌏', keywords: ['earth'], category: 'nature' },
    { emoji: '🌋', keywords: ['volcano'], category: 'nature' },
    { emoji: '⛰️', keywords: ['mountain'], category: 'nature' },
    { emoji: '🏔️', keywords: ['mountain', 'snow'], category: 'nature' },
    { emoji: '🗻', keywords: ['mount', 'fuji'], category: 'nature' },
    { emoji: '🏕️', keywords: ['camping'], category: 'nature' },
    { emoji: '🏖️', keywords: ['beach'], category: 'nature' },
    { emoji: '🏜️', keywords: ['desert'], category: 'nature' },
    { emoji: '🏝️', keywords: ['island'], category: 'nature' },
    { emoji: '🏞️', keywords: ['park'], category: 'nature' },

    // FOOD - 50 adet
    { emoji: '🍏', keywords: ['apple', 'green'], category: 'food' },
    { emoji: '🍎', keywords: ['apple', 'red'], category: 'food' },
    { emoji: '🍐', keywords: ['pear'], category: 'food' },
    { emoji: '🍊', keywords: ['orange', 'tangerine'], category: 'food' },
    { emoji: '🍋', keywords: ['lemon'], category: 'food' },
    { emoji: '🍌', keywords: ['banana'], category: 'food' },
    { emoji: '🍉', keywords: ['watermelon'], category: 'food' },
    { emoji: '🍇', keywords: ['grapes'], category: 'food' },
    { emoji: '🍓', keywords: ['strawberry'], category: 'food' },
    { emoji: '🍈', keywords: ['melon'], category: 'food' },
    { emoji: '🍒', keywords: ['cherries'], category: 'food' },
    { emoji: '🍑', keywords: ['peach'], category: 'food' },
    { emoji: '🍍', keywords: ['pineapple'], category: 'food' },
    { emoji: '🥝', keywords: ['kiwi'], category: 'food' },
    { emoji: '🥑', keywords: ['avocado'], category: 'food' },
    { emoji: '🍅', keywords: ['tomato'], category: 'food' },
    { emoji: '🍆', keywords: ['eggplant'], category: 'food' },
    { emoji: '🥔', keywords: ['potato'], category: 'food' },
    { emoji: '🥕', keywords: ['carrot'], category: 'food' },
    { emoji: '🌽', keywords: ['corn'], category: 'food' },
    { emoji: '🌶️', keywords: ['pepper', 'hot'], category: 'food' },
    { emoji: '🥒', keywords: ['cucumber'], category: 'food' },
    { emoji: '🥬', keywords: ['leafy', 'green'], category: 'food' },
    { emoji: '🥦', keywords: ['broccoli'], category: 'food' },
    { emoji: '🧄', keywords: ['garlic'], category: 'food' },
    { emoji: '🧅', keywords: ['onion'], category: 'food' },
    { emoji: '🍄', keywords: ['mushroom'], category: 'food' },
    { emoji: '🥜', keywords: ['peanuts'], category: 'food' },
    { emoji: '🌰', keywords: ['chestnut'], category: 'food' },
    { emoji: '🍞', keywords: ['bread'], category: 'food' },
    { emoji: '🥐', keywords: ['croissant'], category: 'food' },
    { emoji: '🥖', keywords: ['baguette', 'bread'], category: 'food' },
    { emoji: '🥨', keywords: ['pretzel'], category: 'food' },
    { emoji: '🥯', keywords: ['bagel'], category: 'food' },
    { emoji: '🥞', keywords: ['pancakes'], category: 'food' },
    { emoji: '🧇', keywords: ['waffle'], category: 'food' },
    { emoji: '🧀', keywords: ['cheese'], category: 'food' },
    { emoji: '🍖', keywords: ['meat', 'bone'], category: 'food' },
    { emoji: '🍗', keywords: ['poultry', 'leg'], category: 'food' },
    { emoji: '🥩', keywords: ['steak', 'meat'], category: 'food' },
    { emoji: '🥓', keywords: ['bacon'], category: 'food' },
    { emoji: '🍔', keywords: ['burger', 'hamburger'], category: 'food' },
    { emoji: '🍟', keywords: ['fries', 'french'], category: 'food' },
    { emoji: '🍕', keywords: ['pizza'], category: 'food' },
    { emoji: '🌭', keywords: ['hotdog'], category: 'food' },
    { emoji: '🥪', keywords: ['sandwich'], category: 'food' },
    { emoji: '🌮', keywords: ['taco'], category: 'food' },
    { emoji: '🌯', keywords: ['burrito'], category: 'food' },
    { emoji: '🍳', keywords: ['cooking', 'egg'], category: 'food' },
    { emoji: '🍲', keywords: ['pot', 'food'], category: 'food' },
    { emoji: '🍜', keywords: ['ramen', 'noodles'], category: 'food' },
    { emoji: '🍝', keywords: ['spaghetti', 'pasta'], category: 'food' },
    { emoji: '🍣', keywords: ['sushi'], category: 'food' },
    { emoji: '🍤', keywords: ['shrimp', 'fried'], category: 'food' },
    { emoji: '🍦', keywords: ['icecream', 'soft'], category: 'food' },
    { emoji: '🍧', keywords: ['shaved', 'ice'], category: 'food' },
    { emoji: '🍨', keywords: ['ice', 'cream'], category: 'food' },
    { emoji: '🍩', keywords: ['donut', 'doughnut'], category: 'food' },
    { emoji: '🍪', keywords: ['cookie'], category: 'food' },
    { emoji: '🎂', keywords: ['cake', 'birthday'], category: 'food' },
    { emoji: '🍰', keywords: ['cake', 'shortcake'], category: 'food' },
    { emoji: '🧁', keywords: ['cupcake'], category: 'food' },
    { emoji: '🥧', keywords: ['pie'], category: 'food' },
    { emoji: '🍫', keywords: ['chocolate', 'bar'], category: 'food' },
    { emoji: '🍬', keywords: ['candy'], category: 'food' },
    { emoji: '🍭', keywords: ['lollipop'], category: 'food' },
    { emoji: '🍮', keywords: ['custard', 'pudding'], category: 'food' },
    { emoji: '🍯', keywords: ['honey', 'pot'], category: 'food' },
    { emoji: '🍼', keywords: ['baby', 'bottle'], category: 'food' },
    { emoji: '🥛', keywords: ['milk', 'glass'], category: 'food' },
    { emoji: '☕', keywords: ['coffee', 'tea', 'hot'], category: 'food' },
    { emoji: '🍵', keywords: ['tea', 'cup'], category: 'food' },
    { emoji: '🧃', keywords: ['juice', 'box'], category: 'food' },
    { emoji: '🥤', keywords: ['cup', 'straw'], category: 'food' },
    { emoji: '🍶', keywords: ['sake', 'bottle'], category: 'food' },
    { emoji: '🍺', keywords: ['beer', 'mug'], category: 'food' },
    { emoji: '🍻', keywords: ['beers', 'clink'], category: 'food' },
    { emoji: '🥂', keywords: ['champagne', 'clink'], category: 'food' },
    { emoji: '🍷', keywords: ['wine', 'glass'], category: 'food' },
    { emoji: '🍸', keywords: ['cocktail', 'glass'], category: 'food' },
    { emoji: '🍹', keywords: ['tropical', 'drink'], category: 'food' },
    { emoji: '🍾', keywords: ['champagne', 'bottle'], category: 'food' },

    // ACTIVITY - 40 adet
    { emoji: '⚽', keywords: ['soccer', 'football', 'ball'], category: 'activity' },
    { emoji: '🏀', keywords: ['basketball', 'ball'], category: 'activity' },
    { emoji: '🏈', keywords: ['american', 'football'], category: 'activity' },
    { emoji: '⚾', keywords: ['baseball', 'ball'], category: 'activity' },
    { emoji: '🥎', keywords: ['softball'], category: 'activity' },
    { emoji: '🎾', keywords: ['tennis', 'ball'], category: 'activity' },
    { emoji: '🏐', keywords: ['volleyball', 'ball'], category: 'activity' },
    { emoji: '🏉', keywords: ['rugby', 'football'], category: 'activity' },
    { emoji: '🎱', keywords: ['pool', '8ball'], category: 'activity' },
    { emoji: '🏓', keywords: ['ping', 'pong'], category: 'activity' },
    { emoji: '🏸', keywords: ['badminton'], category: 'activity' },
    { emoji: '🏒', keywords: ['hockey', 'ice'], category: 'activity' },
    { emoji: '🏑', keywords: ['hockey', 'field'], category: 'activity' },
    { emoji: '🥍', keywords: ['lacrosse'], category: 'activity' },
    { emoji: '🏏', keywords: ['cricket'], category: 'activity' },
    { emoji: '⛳', keywords: ['golf', 'flag'], category: 'activity' },
    { emoji: '🏹', keywords: ['bow', 'arrow'], category: 'activity' },
    { emoji: '🎣', keywords: ['fishing', 'pole'], category: 'activity' },
    { emoji: '🤿', keywords: ['diving', 'mask'], category: 'activity' },
    { emoji: '🥊', keywords: ['boxing', 'glove'], category: 'activity' },
    { emoji: '🥋', keywords: ['martial', 'arts'], category: 'activity' },
    { emoji: '⛸️', keywords: ['ice', 'skate'], category: 'activity' },
    { emoji: '🎿', keywords: ['ski', 'snow'], category: 'activity' },
    { emoji: '🛷', keywords: ['sled', 'sleigh'], category: 'activity' },
    { emoji: '🥌', keywords: ['curling', 'stone'], category: 'activity' },
    { emoji: '🎯', keywords: ['target', 'bullseye', 'dart'], category: 'activity' },
    { emoji: '🎮', keywords: ['video', 'game', 'controller'], category: 'activity' },
    { emoji: '🎰', keywords: ['slot', 'machine'], category: 'activity' },
    { emoji: '🎲', keywords: ['dice', 'game'], category: 'activity' },
    { emoji: '🧩', keywords: ['puzzle', 'piece'], category: 'activity' },
    { emoji: '🧸', keywords: ['teddy', 'bear'], category: 'activity' },
    { emoji: '🪀', keywords: ['yo-yo'], category: 'activity' },
    { emoji: '🪁', keywords: ['kite'], category: 'activity' },
    { emoji: '🎨', keywords: ['art', 'palette', 'paint'], category: 'activity' },
    { emoji: '🧵', keywords: ['thread', 'sewing'], category: 'activity' },
    { emoji: '🧶', keywords: ['yarn', 'knitting'], category: 'activity' },
    { emoji: '🎤', keywords: ['microphone', 'sing', 'karaoke'], category: 'activity' },
    { emoji: '🎧', keywords: ['headphone', 'music'], category: 'activity' },
    { emoji: '🎼', keywords: ['music', 'score'], category: 'activity' },
    { emoji: '🎹', keywords: ['piano', 'music', 'keyboard'], category: 'activity' },
    { emoji: '🥁', keywords: ['drum', 'music'], category: 'activity' },
    { emoji: '🎷', keywords: ['saxophone', 'jazz'], category: 'activity' },
    { emoji: '🎺', keywords: ['trumpet', 'music'], category: 'activity' },
    { emoji: '🎸', keywords: ['guitar', 'music'], category: 'activity' },
    { emoji: '🎻', keywords: ['violin', 'music'], category: 'activity' },
    { emoji: '🎬', keywords: ['movie', 'clapper', 'film'], category: 'activity' },

    // TRAVEL - 50 adet
    { emoji: '🚗', keywords: ['car', 'auto', 'vehicle'], category: 'travel' },
    { emoji: '🚕', keywords: ['taxi', 'cab'], category: 'travel' },
    { emoji: '🚙', keywords: ['suv', 'car'], category: 'travel' },
    { emoji: '🚌', keywords: ['bus'], category: 'travel' },
    { emoji: '🏎️', keywords: ['racing', 'car'], category: 'travel' },
    { emoji: '🚓', keywords: ['police', 'car'], category: 'travel' },
    { emoji: '🚑', keywords: ['ambulance'], category: 'travel' },
    { emoji: '🚒', keywords: ['fire', 'engine'], category: 'travel' },
    { emoji: '🚚', keywords: ['truck', 'delivery'], category: 'travel' },
    { emoji: '🚛', keywords: ['lorry', 'truck'], category: 'travel' },
    { emoji: '🚜', keywords: ['tractor'], category: 'travel' },
    { emoji: '🛵', keywords: ['motor', 'scooter'], category: 'travel' },
    { emoji: '🏍️', keywords: ['motorcycle'], category: 'travel' },
    { emoji: '🚲', keywords: ['bike', 'bicycle'], category: 'travel' },
    { emoji: '🛴', keywords: ['scooter', 'kick'], category: 'travel' },
    { emoji: '🚂', keywords: ['train', 'steam'], category: 'travel' },
    { emoji: '🚆', keywords: ['train', 'railway'], category: 'travel' },
    { emoji: '🚇', keywords: ['subway', 'metro'], category: 'travel' },
    { emoji: '🚊', keywords: ['tram'], category: 'travel' },
    { emoji: '🚉', keywords: ['station', 'train'], category: 'travel' },
    { emoji: '🚝', keywords: ['monorail'], category: 'travel' },
    { emoji: '🚞', keywords: ['mountain', 'railway'], category: 'travel' },
    { emoji: '🚋', keywords: ['tram', 'car'], category: 'travel' },
    { emoji: '🚌', keywords: ['bus'], category: 'travel' },
    { emoji: '🚍', keywords: ['bus', 'front'], category: 'travel' },
    { emoji: '🚨', keywords: ['police', 'siren'], category: 'travel' },
    { emoji: '🚥', keywords: ['traffic', 'light'], category: 'travel' },
    { emoji: '🚦', keywords: ['traffic', 'light'], category: 'travel' },
    { emoji: '🛑', keywords: ['stop', 'sign'], category: 'travel' },
    { emoji: '🚧', keywords: ['construction', 'barrier'], category: 'travel' },
    { emoji: '⚓', keywords: ['anchor', 'ship'], category: 'travel' },
    { emoji: '⛵', keywords: ['sailboat', 'boat'], category: 'travel' },
    { emoji: '🛶', keywords: ['canoe', 'boat'], category: 'travel' },
    { emoji: '🚤', keywords: ['speedboat'], category: 'travel' },
    { emoji: '🛳️', keywords: ['passenger', 'ship'], category: 'travel' },
    { emoji: '⛴️', keywords: ['ferry'], category: 'travel' },
    { emoji: '🛥️', keywords: ['motor', 'boat'], category: 'travel' },
    { emoji: '🚢', keywords: ['ship', 'cruise'], category: 'travel' },
    { emoji: '✈️', keywords: ['airplane', 'flight'], category: 'travel' },
    { emoji: '🛩️', keywords: ['small', 'airplane'], category: 'travel' },
    { emoji: '🛫', keywords: ['departure', 'flight'], category: 'travel' },
    { emoji: '🛬', keywords: ['arrival', 'flight'], category: 'travel' },
    { emoji: '🪂', keywords: ['parachute'], category: 'travel' },
    { emoji: '💺', keywords: ['seat', 'chair'], category: 'travel' },
    { emoji: '🚁', keywords: ['helicopter'], category: 'travel' },
    { emoji: '🚟', keywords: ['suspension', 'railway'], category: 'travel' },
    { emoji: '🚠', keywords: ['mountain', 'cableway'], category: 'travel' },
    { emoji: '🚡', keywords: ['aerial', 'tramway'], category: 'travel' },
    { emoji: '🚀', keywords: ['rocket', 'space'], category: 'travel' },
    { emoji: '🛸', keywords: ['ufo', 'flying', 'saucer'], category: 'travel' },
    { emoji: '🌍', keywords: ['earth', 'europe', 'africa'], category: 'travel' },
    { emoji: '🌎', keywords: ['earth', 'americas'], category: 'travel' },
    { emoji: '🌏', keywords: ['earth', 'asia', 'australia'], category: 'travel' },
    { emoji: '🗺️', keywords: ['map', 'world'], category: 'travel' },
    { emoji: '🧭', keywords: ['compass', 'direction'], category: 'travel' },
    { emoji: '🏔️', keywords: ['mountain', 'snow'], category: 'travel' },
    { emoji: '⛰️', keywords: ['mountain'], category: 'travel' },
    { emoji: '🌋', keywords: ['volcano'], category: 'travel' },
    { emoji: '🗻', keywords: ['mount', 'fuji'], category: 'travel' },
    { emoji: '🏕️', keywords: ['camping', 'tent'], category: 'travel' },
    { emoji: '🏖️', keywords: ['beach', 'umbrella'], category: 'travel' },
    { emoji: '🏜️', keywords: ['desert'], category: 'travel' },
    { emoji: '🏝️', keywords: ['island', 'tropical'], category: 'travel' },
    { emoji: '🏞️', keywords: ['park', 'national'], category: 'travel' },
    { emoji: '🏟️', keywords: ['stadium'], category: 'travel' },
    { emoji: '🏛️', keywords: ['classical', 'building'], category: 'travel' },
    { emoji: '🏗️', keywords: ['construction', 'building'], category: 'travel' },
    { emoji: '🧱', keywords: ['brick'], category: 'travel' },
    { emoji: '🏘️', keywords: ['houses', 'buildings'], category: 'travel' },
    { emoji: '🏚️', keywords: ['derelict', 'house'], category: 'travel' },
    { emoji: '🏠', keywords: ['house', 'home'], category: 'travel' },
    { emoji: '🏡', keywords: ['house', 'garden'], category: 'travel' },
    { emoji: '🏢', keywords: ['office', 'building'], category: 'travel' },
    { emoji: '🏣', keywords: ['post', 'office'], category: 'travel' },
    { emoji: '🏥', keywords: ['hospital'], category: 'travel' },
    { emoji: '🏦', keywords: ['bank'], category: 'travel' },
    { emoji: '🏨', keywords: ['hotel'], category: 'travel' },
    { emoji: '🏩', keywords: ['love', 'hotel'], category: 'travel' },
    { emoji: '🏪', keywords: ['convenience', 'store'], category: 'travel' },
    { emoji: '🏫', keywords: ['school'], category: 'travel' },
    { emoji: '🏬', keywords: ['department', 'store'], category: 'travel' },
    { emoji: '🏭', keywords: ['factory'], category: 'travel' },
    { emoji: '🏯', keywords: ['castle', 'japanese'], category: 'travel' },
    { emoji: '🏰', keywords: ['castle', 'european'], category: 'travel' },
    { emoji: '💒', keywords: ['wedding', 'chapel'], category: 'travel' },
    { emoji: '🗼', keywords: ['tokyo', 'tower'], category: 'travel' },
    { emoji: '🗽', keywords: ['statue', 'liberty'], category: 'travel' },
    { emoji: '⛪', keywords: ['church'], category: 'travel' },
    { emoji: '🕌', keywords: ['mosque'], category: 'travel' },
    { emoji: '🛕', keywords: ['hindu', 'temple'], category: 'travel' },
    { emoji: '🕍', keywords: ['synagogue'], category: 'travel' },
    { emoji: '⛩️', keywords: ['shinto', 'shrine'], category: 'travel' },
    { emoji: '🕋', keywords: ['kaaba'], category: 'travel' },

    // OBJECTS - 70 adet
    { emoji: '⌚', keywords: ['watch', 'time'], category: 'objects' },
    { emoji: '📱', keywords: ['phone', 'mobile', 'iphone'], category: 'objects' },
    { emoji: '💻', keywords: ['computer', 'laptop'], category: 'objects' },
    { emoji: '⌨️', keywords: ['keyboard'], category: 'objects' },
    { emoji: '🖥️', keywords: ['desktop', 'computer'], category: 'objects' },
    { emoji: '🖨️', keywords: ['printer'], category: 'objects' },
    { emoji: '🖱️', keywords: ['mouse', 'computer'], category: 'objects' },
    { emoji: '🖲️', keywords: ['trackball'], category: 'objects' },
    { emoji: '🕹️', keywords: ['joystick', 'game'], category: 'objects' },
    { emoji: '💽', keywords: ['disk', 'minidisc'], category: 'objects' },
    { emoji: '💾', keywords: ['floppy', 'disk'], category: 'objects' },
    { emoji: '💿', keywords: ['cd', 'disc'], category: 'objects' },
    { emoji: '📀', keywords: ['dvd', 'disc'], category: 'objects' },
    { emoji: '📼', keywords: ['vhs', 'tape'], category: 'objects' },
    { emoji: '📷', keywords: ['camera', 'photo'], category: 'objects' },
    { emoji: '📸', keywords: ['camera', 'flash'], category: 'objects' },
    { emoji: '📹', keywords: ['video', 'camera'], category: 'objects' },
    { emoji: '🎥', keywords: ['movie', 'camera'], category: 'objects' },
    { emoji: '📽️', keywords: ['film', 'projector'], category: 'objects' },
    { emoji: '🎞️', keywords: ['film', 'frames'], category: 'objects' },
    { emoji: '📞', keywords: ['telephone', 'receiver'], category: 'objects' },
    { emoji: '☎️', keywords: ['telephone', 'phone'], category: 'objects' },
    { emoji: '📟', keywords: ['pager', 'beeper'], category: 'objects' },
    { emoji: '📠', keywords: ['fax', 'machine'], category: 'objects' },
    { emoji: '📺', keywords: ['television', 'tv'], category: 'objects' },
    { emoji: '📻', keywords: ['radio'], category: 'objects' },
    { emoji: '🎙️', keywords: ['studio', 'microphone'], category: 'objects' },
    { emoji: '⏱️', keywords: ['stopwatch'], category: 'objects' },
    { emoji: '⏲️', keywords: ['timer', 'clock'], category: 'objects' },
    { emoji: '⏰', keywords: ['alarm', 'clock'], category: 'objects' },
    { emoji: '🕰️', keywords: ['mantelpiece', 'clock'], category: 'objects' },
    { emoji: '⌛', keywords: ['hourglass', 'done'], category: 'objects' },
    { emoji: '⏳', keywords: ['hourglass', 'not', 'done'], category: 'objects' },
    { emoji: '📡', keywords: ['satellite', 'antenna'], category: 'objects' },
    { emoji: '🔋', keywords: ['battery'], category: 'objects' },
    { emoji: '🔌', keywords: ['electric', 'plug'], category: 'objects' },
    { emoji: '💡', keywords: ['light', 'bulb', 'idea'], category: 'objects' },
    { emoji: '🔦', keywords: ['flashlight'], category: 'objects' },
    { emoji: '🕯️', keywords: ['candle'], category: 'objects' },
    { emoji: '🪔', keywords: ['diya', 'lamp'], category: 'objects' },
    { emoji: '🧯', keywords: ['fire', 'extinguisher'], category: 'objects' },
    { emoji: '💸', keywords: ['money', 'wings', 'fly'], category: 'objects' },
    { emoji: '💵', keywords: ['dollar', 'money'], category: 'objects' },
    { emoji: '💴', keywords: ['yen', 'money'], category: 'objects' },
    { emoji: '💶', keywords: ['euro', 'money'], category: 'objects' },
    { emoji: '💷', keywords: ['pound', 'money'], category: 'objects' },
    { emoji: '💰', keywords: ['money', 'bag'], category: 'objects' },
    { emoji: '💳', keywords: ['credit', 'card'], category: 'objects' },
    { emoji: '💎', keywords: ['gem', 'stone', 'diamond'], category: 'objects' },
    { emoji: '⚖️', keywords: ['balance', 'scale'], category: 'objects' },
    { emoji: '🧰', keywords: ['toolbox'], category: 'objects' },
    { emoji: '🔧', keywords: ['wrench'], category: 'objects' },
    { emoji: '🔨', keywords: ['hammer'], category: 'objects' },
    { emoji: '⚒️', keywords: ['hammer', 'pick'], category: 'objects' },
    { emoji: '🛠️', keywords: ['hammer', 'wrench'], category: 'objects' },
    { emoji: '⛏️', keywords: ['pick'], category: 'objects' },
    { emoji: '🔩', keywords: ['nut', 'bolt'], category: 'objects' },
    { emoji: '⚙️', keywords: ['gear'], category: 'objects' },
    { emoji: '🧱', keywords: ['bricks'], category: 'objects' },
    { emoji: '⛓️', keywords: ['chains'], category: 'objects' },
    { emoji: '🧲', keywords: ['magnet'], category: 'objects' },
    { emoji: '🔫', keywords: ['pistol', 'gun', 'water'], category: 'objects' },
    { emoji: '💣', keywords: ['bomb'], category: 'objects' },
    { emoji: '🧨', keywords: ['firecracker'], category: 'objects' },
    { emoji: '🔪', keywords: ['kitchen', 'knife'], category: 'objects' },
    { emoji: '🗡️', keywords: ['dagger'], category: 'objects' },
    { emoji: '⚔️', keywords: ['crossed', 'swords'], category: 'objects' },
    { emoji: '🛡️', keywords: ['shield'], category: 'objects' },
    { emoji: '🚬', keywords: ['cigarette', 'smoking'], category: 'objects' },
    { emoji: '⚰️', keywords: ['coffin'], category: 'objects' },
    { emoji: '⚱️', keywords: ['funeral', 'urn'], category: 'objects' },
    { emoji: '🏺', keywords: ['amphora'], category: 'objects' },
    { emoji: '🔮', keywords: ['crystal', 'ball'], category: 'objects' },
    { emoji: '📿', keywords: ['prayer', 'beads'], category: 'objects' },
    { emoji: '🧿', keywords: ['nazar', 'amulet'], category: 'objects' },
    { emoji: '💈', keywords: ['barber', 'pole'], category: 'objects' },
    { emoji: '⚗️', keywords: ['alembic'], category: 'objects' },
    { emoji: '🔭', keywords: ['telescope'], category: 'objects' },
    { emoji: '🔬', keywords: ['microscope'], category: 'objects' },
    { emoji: '🕳️', keywords: ['hole'], category: 'objects' },
    { emoji: '🩹', keywords: ['adhesive', 'bandage'], category: 'objects' },
    { emoji: '🩺', keywords: ['stethoscope'], category: 'objects' },
    { emoji: '🚪', keywords: ['door'], category: 'objects' },
    { emoji: '🛗', keywords: ['elevator'], category: 'objects' },
    { emoji: '🪞', keywords: ['mirror'], category: 'objects' },
    { emoji: '🪟', keywords: ['window'], category: 'objects' },
    { emoji: '🛏️', keywords: ['bed'], category: 'objects' },
    { emoji: '🛋️', keywords: ['couch', 'lamp'], category: 'objects' },
    { emoji: '🪑', keywords: ['chair'], category: 'objects' },
    { emoji: '🚽', keywords: ['toilet'], category: 'objects' },
    { emoji: '🪠', keywords: ['plunger'], category: 'objects' },
    { emoji: '🚿', keywords: ['shower'], category: 'objects' },
    { emoji: '🛁', keywords: ['bathtub'], category: 'objects' },
    { emoji: '🪤', keywords: ['mouse', 'trap'], category: 'objects' },
    { emoji: '🪒', keywords: ['razor'], category: 'objects' },
    { emoji: '🧴', keywords: ['lotion', 'bottle'], category: 'objects' },
    { emoji: '🧷', keywords: ['safety', 'pin'], category: 'objects' },
    { emoji: '🧹', keywords: ['broom'], category: 'objects' },
    { emoji: '🧺', keywords: ['basket'], category: 'objects' },
    { emoji: '🧻', keywords: ['roll', 'paper', 'toilet'], category: 'objects' },
    { emoji: '🧼', keywords: ['soap'], category: 'objects' },
    { emoji: '🧽', keywords: ['sponge'], category: 'objects' },
    { emoji: '🧯', keywords: ['fire', 'extinguisher'], category: 'objects' },
    { emoji: '🛒', keywords: ['shopping', 'cart'], category: 'objects' },
    { emoji: '🚰', keywords: ['potable', 'water'], category: 'objects' },
    { emoji: '💌', keywords: ['love', 'letter'], category: 'objects' },
    { emoji: '💣', keywords: ['bomb'], category: 'objects' },
    { emoji: '🔑', keywords: ['key', 'lock'], category: 'objects' },
    { emoji: '🗝️', keywords: ['old', 'key'], category: 'objects' },
    { emoji: '🚪', keywords: ['door'], category: 'objects' },
    { emoji: '🪑', keywords: ['chair'], category: 'objects' },
    { emoji: '🛋️', keywords: ['couch'], category: 'objects' },
    { emoji: '🛏️', keywords: ['bed'], category: 'objects' },
    { emoji: '🚽', keywords: ['toilet'], category: 'objects' },
    { emoji: '🚿', keywords: ['shower'], category: 'objects' },
    { emoji: '🛁', keywords: ['bathtub'], category: 'objects' },
    { emoji: '🧸', keywords: ['teddy', 'bear'], category: 'objects' },
    { emoji: '🪀', keywords: ['yo-yo'], category: 'objects' },
    { emoji: '🪁', keywords: ['kite'], category: 'objects' },
    { emoji: '🎨', keywords: ['palette'], category: 'objects' },
    { emoji: '🧵', keywords: ['thread'], category: 'objects' },
    { emoji: '🧶', keywords: ['yarn'], category: 'objects' },
    { emoji: '👔', keywords: ['necktie', 'shirt'], category: 'objects' },
    { emoji: '👕', keywords: ['shirt', 'tshirt'], category: 'objects' },
    { emoji: '👖', keywords: ['jeans', 'pants'], category: 'objects' },
    { emoji: '🧣', keywords: ['scarf'], category: 'objects' },
    { emoji: '🧤', keywords: ['gloves'], category: 'objects' },
    { emoji: '🧥', keywords: ['coat'], category: 'objects' },
    { emoji: '🧦', keywords: ['socks'], category: 'objects' },
    { emoji: '👗', keywords: ['dress'], category: 'objects' },
    { emoji: '👘', keywords: ['kimono'], category: 'objects' },
    { emoji: '🥻', keywords: ['sari'], category: 'objects' },
    { emoji: '🩱', keywords: ['swimsuit'], category: 'objects' },
    { emoji: '👙', keywords: ['bikini'], category: 'objects' },
    { emoji: '👚', keywords: ['blouse'], category: 'objects' },
    { emoji: '👛', keywords: ['purse'], category: 'objects' },
    { emoji: '👜', keywords: ['handbag'], category: 'objects' },
    { emoji: '👝', keywords: ['pouch'], category: 'objects' },
    { emoji: '🛍️', keywords: ['shopping', 'bags'], category: 'objects' },
    { emoji: '🎒', keywords: ['backpack'], category: 'objects' },
    { emoji: '👞', keywords: ['shoe', 'mans'], category: 'objects' },
    { emoji: '👟', keywords: ['running', 'shoe'], category: 'objects' },
    { emoji: '🥾', keywords: ['hiking', 'boot'], category: 'objects' },
    { emoji: '🥿', keywords: ['flat', 'shoe'], category: 'objects' },
    { emoji: '👠', keywords: ['high', 'heel'], category: 'objects' },
    { emoji: '👡', keywords: ['sandal', 'woman'], category: 'objects' },
    { emoji: '🩰', keywords: ['ballet', 'shoes'], category: 'objects' },
    { emoji: '👢', keywords: ['boot', 'woman'], category: 'objects' },
    { emoji: '👑', keywords: ['crown', 'king'], category: 'objects' },
    { emoji: '👒', keywords: ['hat', 'woman'], category: 'objects' },
    { emoji: '🎩', keywords: ['top', 'hat'], category: 'objects' },
    { emoji: '🎓', keywords: ['graduation', 'cap'], category: 'objects' },
    { emoji: '🧢', keywords: ['cap', 'billed'], category: 'objects' },
    { emoji: '💄', keywords: ['lipstick'], category: 'objects' },
    { emoji: '💍', keywords: ['ring'], category: 'objects' },
    { emoji: '💎', keywords: ['gem', 'stone'], category: 'objects' },
    { emoji: '🔇', keywords: ['muted', 'speaker'], category: 'objects' },
    { emoji: '🔈', keywords: ['low', 'volume'], category: 'objects' },
    { emoji: '🔉', keywords: ['medium', 'volume'], category: 'objects' },
    { emoji: '🔊', keywords: ['high', 'volume'], category: 'objects' },
    { emoji: '📢', keywords: ['loudspeaker'], category: 'objects' },
    { emoji: '📣', keywords: ['megaphone'], category: 'objects' },
    { emoji: '📯', keywords: ['postal', 'horn'], category: 'objects' },
    { emoji: '🔔', keywords: ['bell'], category: 'objects' },
    { emoji: '🔕', keywords: ['bell', 'slash'], category: 'objects' },
    { emoji: '🎼', keywords: ['musical', 'score'], category: 'objects' },
    { emoji: '🎵', keywords: ['note'], category: 'objects' },
    { emoji: '🎶', keywords: ['notes'], category: 'objects' },
    { emoji: '🎙️', keywords: ['studio', 'microphone'], category: 'objects' },
    { emoji: '🎚️', keywords: ['level', 'slider'], category: 'objects' },
    { emoji: '🎛️', keywords: ['control', 'knobs'], category: 'objects' },
    { emoji: '🎤', keywords: ['microphone'], category: 'objects' },
    { emoji: '🎧', keywords: ['headphone'], category: 'objects' },
    { emoji: '📻', keywords: ['radio'], category: 'objects' },
    { emoji: '🎷', keywords: ['saxophone'], category: 'objects' },
    { emoji: '🎸', keywords: ['guitar'], category: 'objects' },
    { emoji: '🎹', keywords: ['musical', 'keyboard'], category: 'objects' },
    { emoji: '🎺', keywords: ['trumpet'], category: 'objects' },
    { emoji: '🎻', keywords: ['violin'], category: 'objects' },
    { emoji: '🥁', keywords: ['drum'], category: 'objects' },
    { emoji: '📱', keywords: ['mobile', 'phone'], category: 'objects' },
    { emoji: '📲', keywords: ['mobile', 'phone', 'arrow'], category: 'objects' },
    { emoji: '☎️', keywords: ['telephone'], category: 'objects' },
    { emoji: '📞', keywords: ['telephone', 'receiver'], category: 'objects' },
    { emoji: '📟', keywords: ['pager'], category: 'objects' },
    { emoji: '📠', keywords: ['fax', 'machine'], category: 'objects' },
    { emoji: '🔋', keywords: ['battery'], category: 'objects' },
    { emoji: '🔌', keywords: ['electric', 'plug'], category: 'objects' },
    { emoji: '💻', keywords: ['laptop'], category: 'objects' },
    { emoji: '🖥️', keywords: ['desktop', 'computer'], category: 'objects' },
    { emoji: '🖨️', keywords: ['printer'], category: 'objects' },
    { emoji: '⌨️', keywords: ['keyboard'], category: 'objects' },
    { emoji: '🖱️', keywords: ['computer', 'mouse'], category: 'objects' },
    { emoji: '🖲️', keywords: ['trackball'], category: 'objects' },
    { emoji: '💽', keywords: ['computer', 'disk'], category: 'objects' },
    { emoji: '💾', keywords: ['floppy', 'disk'], category: 'objects' },
    { emoji: '💿', keywords: ['optical', 'disk'], category: 'objects' },
    { emoji: '📀', keywords: ['dvd'], category: 'objects' },
    { emoji: '🧮', keywords: ['abacus'], category: 'objects' },
    { emoji: '🎥', keywords: ['movie', 'camera'], category: 'objects' },
    { emoji: '🎞️', keywords: ['film', 'frames'], category: 'objects' },
    { emoji: '📽️', keywords: ['film', 'projector'], category: 'objects' },
    { emoji: '📺', keywords: ['television'], category: 'objects' },
    { emoji: '📷', keywords: ['camera'], category: 'objects' },
    { emoji: '📸', keywords: ['camera', 'flash'], category: 'objects' },
    { emoji: '📹', keywords: ['video', 'camera'], category: 'objects' },
    { emoji: '📼', keywords: ['videocassette'], category: 'objects' },
    { emoji: '🔍', keywords: ['magnifying', 'glass'], category: 'objects' },
    { emoji: '🔎', keywords: ['magnifying', 'glass'], category: 'objects' },
    { emoji: '🕯️', keywords: ['candle'], category: 'objects' },
    { emoji: '💡', keywords: ['light', 'bulb'], category: 'objects' },
    { emoji: '🔦', keywords: ['flashlight'], category: 'objects' },
    { emoji: '🏮', keywords: ['red', 'paper', 'lantern'], category: 'objects' },
    { emoji: '🪔', keywords: ['diya', 'lamp'], category: 'objects' },
    { emoji: '📔', keywords: ['notebook'], category: 'objects' },
    { emoji: '📕', keywords: ['closed', 'book'], category: 'objects' },
    { emoji: '📖', keywords: ['open', 'book'], category: 'objects' },
    { emoji: '📗', keywords: ['green', 'book'], category: 'objects' },
    { emoji: '📘', keywords: ['blue', 'book'], category: 'objects' },
    { emoji: '📙', keywords: ['orange', 'book'], category: 'objects' },
    { emoji: '📚', keywords: ['books'], category: 'objects' },
    { emoji: '📓', keywords: ['notebook'], category: 'objects' },
    { emoji: '📒', keywords: ['ledger'], category: 'objects' },
    { emoji: '📃', keywords: ['page', 'curl'], category: 'objects' },
    { emoji: '📜', keywords: ['scroll'], category: 'objects' },
    { emoji: '📄', keywords: ['page', 'facing', 'up'], category: 'objects' },
    { emoji: '📰', keywords: ['newspaper'], category: 'objects' },
    { emoji: '🗞️', keywords: ['rolled', 'newspaper'], category: 'objects' },
    { emoji: '📑', keywords: ['bookmark', 'tabs'], category: 'objects' },
    { emoji: '🔖', keywords: ['bookmark'], category: 'objects' },
    { emoji: '🏷️', keywords: ['label'], category: 'objects' },
    { emoji: '💰', keywords: ['money', 'bag'], category: 'objects' },
    { emoji: '🪙', keywords: ['coin'], category: 'objects' },
    { emoji: '💴', keywords: ['yen', 'banknote'], category: 'objects' },
    { emoji: '💵', keywords: ['dollar', 'banknote'], category: 'objects' },
    { emoji: '💶', keywords: ['euro', 'banknote'], category: 'objects' },
    { emoji: '💷', keywords: ['pound', 'banknote'], category: 'objects' },
    { emoji: '💸', keywords: ['money', 'wings'], category: 'objects' },
    { emoji: '💳', keywords: ['credit', 'card'], category: 'objects' },
    { emoji: '🧾', keywords: ['receipt'], category: 'objects' },
    { emoji: '💹', keywords: ['chart', 'increasing'], category: 'objects' },
    { emoji: '✉️', keywords: ['envelope'], category: 'objects' },
    { emoji: '📧', keywords: ['e-mail'], category: 'objects' },
    { emoji: '📨', keywords: ['incoming', 'envelope'], category: 'objects' },
    { emoji: '📩', keywords: ['envelope', 'arrow'], category: 'objects' },
    { emoji: '📤', keywords: ['outbox', 'tray'], category: 'objects' },
    { emoji: '📥', keywords: ['inbox', 'tray'], category: 'objects' },
    { emoji: '📦', keywords: ['package'], category: 'objects' },
    { emoji: '📫', keywords: ['mailbox', 'closed'], category: 'objects' },
    { emoji: '📪', keywords: ['mailbox', 'closed'], category: 'objects' },
    { emoji: '📬', keywords: ['mailbox', 'open'], category: 'objects' },
    { emoji: '📭', keywords: ['mailbox', 'open'], category: 'objects' },
    { emoji: '📮', keywords: ['postbox'], category: 'objects' },
    { emoji: '🗳️', keywords: ['ballot', 'box'], category: 'objects' },
    { emoji: '✏️', keywords: ['pencil'], category: 'objects' },
    { emoji: '✒️', keywords: ['black', 'nib'], category: 'objects' },
    { emoji: '🖋️', keywords: ['fountain', 'pen'], category: 'objects' },
    { emoji: '🖊️', keywords: ['pen'], category: 'objects' },
    { emoji: '🖌️', keywords: ['paintbrush'], category: 'objects' },
    { emoji: '🖍️', keywords: ['crayon'], category: 'objects' },
    { emoji: '📝', keywords: ['memo'], category: 'objects' },
    { emoji: '💼', keywords: ['briefcase'], category: 'objects' },
    { emoji: '📁', keywords: ['file', 'folder'], category: 'objects' },
    { emoji: '📂', keywords: ['open', 'file', 'folder'], category: 'objects' },
    { emoji: '🗂️', keywords: ['card', 'index', 'dividers'], category: 'objects' },
    { emoji: '📅', keywords: ['calendar'], category: 'objects' },
    { emoji: '📆', keywords: ['tear-off', 'calendar'], category: 'objects' },
    { emoji: '🗒️', keywords: ['spiral', 'notepad'], category: 'objects' },
    { emoji: '🗓️', keywords: ['spiral', 'calendar'], category: 'objects' },
    { emoji: '📇', keywords: ['card', 'index'], category: 'objects' },
    { emoji: '📈', keywords: ['chart', 'increasing'], category: 'objects' },
    { emoji: '📉', keywords: ['chart', 'decreasing'], category: 'objects' },
    { emoji: '📊', keywords: ['bar', 'chart'], category: 'objects' },
    { emoji: '📋', keywords: ['clipboard'], category: 'objects' },
    { emoji: '📌', keywords: ['pushpin'], category: 'objects' },
    { emoji: '📍', keywords: ['round', 'pushpin'], category: 'objects' },
    { emoji: '📎', keywords: ['paperclip'], category: 'objects' },
    { emoji: '🖇️', keywords: ['linked', 'paperclips'], category: 'objects' },
    { emoji: '📏', keywords: ['straight', 'ruler'], category: 'objects' },
    { emoji: '📐', keywords: ['triangular', 'ruler'], category: 'objects' },
    { emoji: '✂️', keywords: ['scissors'], category: 'objects' },
    { emoji: '🗃️', keywords: ['card', 'file', 'box'], category: 'objects' },
    { emoji: '🗄️', keywords: ['file', 'cabinet'], category: 'objects' },
    { emoji: '🗑️', keywords: ['wastebasket'], category: 'objects' },
    { emoji: '🔒', keywords: ['locked'], category: 'objects' },
    { emoji: '🔓', keywords: ['unlocked'], category: 'objects' },
    { emoji: '🔏', keywords: ['locked', 'pen'], category: 'objects' },
    { emoji: '🔐', keywords: ['locked', 'key'], category: 'objects' },
    { emoji: '🔑', keywords: ['key'], category: 'objects' },
    { emoji: '🗝️', keywords: ['old', 'key'], category: 'objects' },
    { emoji: '🔨', keywords: ['hammer'], category: 'objects' },
    { emoji: '⛏️', keywords: ['pick'], category: 'objects' },
    { emoji: '⚒️', keywords: ['hammer', 'pick'], category: 'objects' },
    { emoji: '🛠️', keywords: ['hammer', 'wrench'], category: 'objects' },
    { emoji: '🗡️', keywords: ['dagger'], category: 'objects' },
    { emoji: '⚔️', keywords: ['crossed', 'swords'], category: 'objects' },
    { emoji: '🔫', keywords: ['pistol'], category: 'objects' },
    { emoji: '🏹', keywords: ['bow', 'arrow'], category: 'objects' },
    { emoji: '🛡️', keywords: ['shield'], category: 'objects' },
    { emoji: '🔧', keywords: ['wrench'], category: 'objects' },
    { emoji: '🔩', keywords: ['nut', 'bolt'], category: 'objects' },
    { emoji: '⚙️', keywords: ['gear'], category: 'objects' },
    { emoji: '🗜️', keywords: ['clamp'], category: 'objects' },
    { emoji: '⚖️', keywords: ['balance', 'scale'], category: 'objects' },
    { emoji: '🦯', keywords: ['white', 'cane'], category: 'objects' },
    { emoji: '🔗', keywords: ['link'], category: 'objects' },
    { emoji: '⛓️', keywords: ['chains'], category: 'objects' },
    { emoji: '🧰', keywords: ['toolbox'], category: 'objects' },
    { emoji: '🧲', keywords: ['magnet'], category: 'objects' },
    { emoji: '🪛', keywords: ['screwdriver'], category: 'objects' },
    { emoji: '🪜', keywords: ['ladder'], category: 'objects' },
    { emoji: '⚗️', keywords: ['alembic'], category: 'objects' },
    { emoji: '🧪', keywords: ['test', 'tube'], category: 'objects' },
    { emoji: '🧫', keywords: ['petri', 'dish'], category: 'objects' },
    { emoji: '🧬', keywords: ['dna'], category: 'objects' },
    { emoji: '🔬', keywords: ['microscope'], category: 'objects' },
    { emoji: '🔭', keywords: ['telescope'], category: 'objects' },
    { emoji: '📡', keywords: ['satellite', 'antenna'], category: 'objects' },
    { emoji: '💉', keywords: ['syringe'], category: 'objects' },
    { emoji: '🩸', keywords: ['drop', 'blood'], category: 'objects' },
    { emoji: '💊', keywords: ['pill'], category: 'objects' },
    { emoji: '🩹', keywords: ['adhesive', 'bandage'], category: 'objects' },
    { emoji: '🩺', keywords: ['stethoscope'], category: 'objects' },
    { emoji: '🌡️', keywords: ['thermometer'], category: 'objects' },
    { emoji: '🧹', keywords: ['broom'], category: 'objects' },
    { emoji: '🧺', keywords: ['basket'], category: 'objects' },
    { emoji: '🧻', keywords: ['roll', 'paper'], category: 'objects' },
    { emoji: '🧼', keywords: ['soap'], category: 'objects' },
    { emoji: '🧽', keywords: ['sponge'], category: 'objects' },
    { emoji: '🧯', keywords: ['fire', 'extinguisher'], category: 'objects' },
    { emoji: '🛒', keywords: ['shopping', 'cart'], category: 'objects' },
    { emoji: '🚰', keywords: ['potable', 'water'], category: 'objects' },
    { emoji: '🚿', keywords: ['shower'], category: 'objects' },
    { emoji: '🛁', keywords: ['bathtub'], category: 'objects' },
    { emoji: '🛀', keywords: ['person', 'taking', 'bath'], category: 'objects' },
    { emoji: '🪒', keywords: ['razor'], category: 'objects' },
    { emoji: '🧴', keywords: ['lotion', 'bottle'], category: 'objects' },
    { emoji: '🧷', keywords: ['safety', 'pin'], category: 'objects' },
    { emoji: '🧹', keywords: ['broom'], category: 'objects' },
    { emoji: '🧺', keywords: ['basket'], category: 'objects' },
    { emoji: '🧻', keywords: ['roll', 'paper'], category: 'objects' },
    { emoji: '🧼', keywords: ['soap'], category: 'objects' },
    { emoji: '🧽', keywords: ['sponge'], category: 'objects' },
    { emoji: '🧯', keywords: ['fire', 'extinguisher'], category: 'objects' },
    { emoji: '🛒', keywords: ['shopping', 'cart'], category: 'objects' },
    { emoji: '🚬', keywords: ['cigarette'], category: 'objects' },
    { emoji: '⚰️', keywords: ['coffin'], category: 'objects' },
    { emoji: '⚱️', keywords: ['funeral', 'urn'], category: 'objects' },
    { emoji: '🗿', keywords: ['moai'], category: 'objects' },
    { emoji: '🪧', keywords: ['placard'], category: 'objects' },
    { emoji: '🚮', keywords: ['litter', 'bin'], category: 'objects' },
    { emoji: '🚰', keywords: ['potable', 'water'], category: 'objects' },
    { emoji: '🚹', keywords: ['men', 'room'], category: 'objects' },
    { emoji: '🚺', keywords: ['women', 'room'], category: 'objects' },
    { emoji: '🚻', keywords: ['restroom'], category: 'objects' },
    { emoji: '🚼', keywords: ['baby', 'symbol'], category: 'objects' },
    { emoji: '🚾', keywords: ['water', 'closet'], category: 'objects' },
    { emoji: '🛂', keywords: ['passport', 'control'], category: 'objects' },
    { emoji: '🛃', keywords: ['customs'], category: 'objects' },
    { emoji: '🛄', keywords: ['baggage', 'claim'], category: 'objects' },
    { emoji: '🛅', keywords: ['left', 'luggage'], category: 'objects' },
    { emoji: '⚠️', keywords: ['warning'], category: 'objects' },
    { emoji: '🚸', keywords: ['children', 'crossing'], category: 'objects' },
    { emoji: '⛔', keywords: ['no', 'entry'], category: 'objects' },
    { emoji: '🚫', keywords: ['prohibited'], category: 'objects' },
    { emoji: '🚳', keywords: ['no', 'bicycles'], category: 'objects' },
    { emoji: '🚭', keywords: ['no', 'smoking'], category: 'objects' },
    { emoji: '🚯', keywords: ['no', 'littering'], category: 'objects' },
    { emoji: '🚱', keywords: ['non-potable', 'water'], category: 'objects' },
    { emoji: '🚷', keywords: ['no', 'pedestrians'], category: 'objects' },
    { emoji: '📵', keywords: ['no', 'mobile', 'phones'], category: 'objects' },
    { emoji: '🔞', keywords: ['no', 'one', 'under', 'eighteen'], category: 'objects' },
    { emoji: '☢️', keywords: ['radioactive'], category: 'objects' },
    { emoji: '☣️', keywords: ['biohazard'], category: 'objects' },
    { emoji: '⬆️', keywords: ['up', 'arrow'], category: 'objects' },
    { emoji: '↗️', keywords: ['up-right', 'arrow'], category: 'objects' },
    { emoji: '➡️', keywords: ['right', 'arrow'], category: 'objects' },
    { emoji: '↘️', keywords: ['down-right', 'arrow'], category: 'objects' },
    { emoji: '⬇️', keywords: ['down', 'arrow'], category: 'objects' },
    { emoji: '↙️', keywords: ['down-left', 'arrow'], category: 'objects' },
    { emoji: '⬅️', keywords: ['left', 'arrow'], category: 'objects' },
    { emoji: '↖️', keywords: ['up-left', 'arrow'], category: 'objects' },
    { emoji: '↕️', keywords: ['up-down', 'arrow'], category: 'objects' },
    { emoji: '↔️', keywords: ['left-right', 'arrow'], category: 'objects' },
    { emoji: '↩️', keywords: ['right', 'arrow', 'curving', 'left'], category: 'objects' },
    { emoji: '↪️', keywords: ['left', 'arrow', 'curving', 'right'], category: 'objects' },
    { emoji: '⤴️', keywords: ['right', 'arrow', 'curving', 'up'], category: 'objects' },
    { emoji: '⤵️', keywords: ['right', 'arrow', 'curving', 'down'], category: 'objects' },
    { emoji: '🔀', keywords: ['shuffle', 'tracks'], category: 'objects' },
    { emoji: '🔁', keywords: ['repeat'], category: 'objects' },
    { emoji: '🔂', keywords: ['repeat', 'single'], category: 'objects' },
    { emoji: '🔄', keywords: ['counterclockwise', 'arrows'], category: 'objects' },
    { emoji: '🔃', keywords: ['clockwise', 'vertical', 'arrows'], category: 'objects' },
    { emoji: '🎵', keywords: ['musical', 'note'], category: 'objects' },
    { emoji: '🎶', keywords: ['musical', 'notes'], category: 'objects' },
    { emoji: '🔼', keywords: ['upwards'], category: 'objects' },
    { emoji: '🔽', keywords: ['downwards'], category: 'objects' },
    { emoji: '➕', keywords: ['plus'], category: 'objects' },
    { emoji: '➖', keywords: ['minus'], category: 'objects' },
    { emoji: '➗', keywords: ['divide'], category: 'objects' },
    { emoji: '✖️', keywords: ['multiply'], category: 'objects' },
    { emoji: '♾️', keywords: ['infinity'], category: 'objects' },
    { emoji: '💲', keywords: ['heavy', 'dollar'], category: 'objects' },
    { emoji: '💱', keywords: ['currency', 'exchange'], category: 'objects' },
    { emoji: '™️', keywords: ['trade', 'mark'], category: 'objects' },
    { emoji: '©️', keywords: ['copyright'], category: 'objects' },
    { emoji: '®️', keywords: ['registered'], category: 'objects' },
    { emoji: '〰️', keywords: ['wavy', 'dash'], category: 'objects' },
    { emoji: '➰', keywords: ['curly', 'loop'], category: 'objects' },
    { emoji: '➿', keywords: ['double', 'curly', 'loop'], category: 'objects' },
    { emoji: '🔚', keywords: ['end'], category: 'objects' },
    { emoji: '🔙', keywords: ['back'], category: 'objects' },
    { emoji: '🔛', keywords: ['on'], category: 'objects' },
    { emoji: '🔝', keywords: ['top'], category: 'objects' },
    { emoji: '🔜', keywords: ['soon'], category: 'objects' },
    { emoji: '✔️', keywords: ['check', 'mark'], category: 'objects' },
    { emoji: '☑️', keywords: ['checkbox'], category: 'objects' },
    { emoji: '🔘', keywords: ['radio'], category: 'objects' },
    { emoji: '🔴', keywords: ['red', 'circle'], category: 'objects' },
    { emoji: '🟠', keywords: ['orange', 'circle'], category: 'objects' },
    { emoji: '🟡', keywords: ['yellow', 'circle'], category: 'objects' },
    { emoji: '🟢', keywords: ['green', 'circle'], category: 'objects' },
    { emoji: '🔵', keywords: ['blue', 'circle'], category: 'objects' },
    { emoji: '🟣', keywords: ['purple', 'circle'], category: 'objects' },
    { emoji: '⚫', keywords: ['black', 'circle'], category: 'objects' },
    { emoji: '⚪', keywords: ['white', 'circle'], category: 'objects' },
    { emoji: '🟤', keywords: ['brown', 'circle'], category: 'objects' },
    { emoji: '🔺', keywords: ['red', 'triangle'], category: 'objects' },
    { emoji: '🔻', keywords: ['red', 'triangle'], category: 'objects' },
    { emoji: '🔸', keywords: ['small', 'orange', 'diamond'], category: 'objects' },
    { emoji: '🔹', keywords: ['small', 'blue', 'diamond'], category: 'objects' },
    { emoji: '🔶', keywords: ['large', 'orange', 'diamond'], category: 'objects' },
    { emoji: '🔷', keywords: ['large', 'blue', 'diamond'], category: 'objects' },
    { emoji: '🔳', keywords: ['white', 'square'], category: 'objects' },
    { emoji: '🔲', keywords: ['black', 'square'], category: 'objects' },
    { emoji: '▪️', keywords: ['small', 'black', 'square'], category: 'objects' },
    { emoji: '▫️', keywords: ['small', 'white', 'square'], category: 'objects' },
    { emoji: '◾', keywords: ['medium', 'small', 'black', 'square'], category: 'objects' },
    { emoji: '◽', keywords: ['medium', 'small', 'white', 'square'], category: 'objects' },
    { emoji: '◼️', keywords: ['medium', 'black', 'square'], category: 'objects' },
    { emoji: '◻️', keywords: ['medium', 'white', 'square'], category: 'objects' },
    { emoji: '🟥', keywords: ['red', 'square'], category: 'objects' },
    { emoji: '🟧', keywords: ['orange', 'square'], category: 'objects' },
    { emoji: '🟨', keywords: ['yellow', 'square'], category: 'objects' },
    { emoji: '🟩', keywords: ['green', 'square'], category: 'objects' },
    { emoji: '🟦', keywords: ['blue', 'square'], category: 'objects' },
    { emoji: '🟪', keywords: ['purple', 'square'], category: 'objects' },
    { emoji: '⬛', keywords: ['large', 'black', 'square'], category: 'objects' },
    { emoji: '⬜', keywords: ['large', 'white', 'square'], category: 'objects' },
    { emoji: '🟫', keywords: ['brown', 'square'], category: 'objects' },
    { emoji: '🔈', keywords: ['speaker'], category: 'objects' },
    { emoji: '🔇', keywords: ['muted'], category: 'objects' },
    { emoji: '🔉', keywords: ['speaker'], category: 'objects' },
    { emoji: '🔊', keywords: ['speaker'], category: 'objects' },
    { emoji: '🔔', keywords: ['bell'], category: 'objects' },
    { emoji: '🔕', keywords: ['bell', 'slash'], category: 'objects' },
    { emoji: '📣', keywords: ['megaphone'], category: 'objects' },
    { emoji: '📢', keywords: ['loudspeaker'], category: 'objects' }
];

export const emojiCategories = [
    { id: 'all', label: 'Tümü' },
    { id: 'smileys', label: 'Yüzler' },
    { id: 'gestures', label: 'El & Vücut' },
    { id: 'hearts', label: 'Kalp & Din' },
    { id: 'symbols', label: 'Simgeler' },
    { id: 'party', label: 'Parti & Eğlence' },
    { id: 'nature', label: 'Doğa & Hayvan' },
    { id: 'food', label: 'Yemek & İçecek' },
    { id: 'activity', label: 'Aktivite & Spor' },
    { id: 'travel', label: 'Seyahat & Yerler' },
    { id: 'objects', label: 'Nesneler' }
];

// Emoji karşılaştırma fonksiyonu (varyasyon seçicili emojiler için)
export function normalizeEmoji(emoji: string): string {
    // Varyasyon seçicileri kaldır (\uFE0F ve \u200D)
    return emoji.replace(/\uFE0F/g, '').replace(/\u200D/g, '').trim();
}

// Emoji bulma fonksiyonu
export function findEmoji(emoji: string, catalog: typeof emojiCatalog): typeof emojiCatalog[0] | undefined {
    const normalized = normalizeEmoji(emoji);
    return catalog.find(item => normalizeEmoji(item.emoji) === normalized);
}
